import * as Sentry from "@sentry/sveltekit";
import profileStore from "@/stores/profile";
import { get } from "svelte/store";
import { SENTRY_DSN, SENTRY_OPTIONS } from "@/constants/constants";

const profileState = get(profileStore);
export const initSentry = () => {
  Sentry.init({
    dsn: SENTRY_DSN,
    tracesSampleRate: 1.0,
    environment: process.env.ACTIVE_ENV,
    ...SENTRY_OPTIONS,
  });
  Sentry.setUser({ id: profileState.userId });
};
